import { Auth, EventInterface } from '@weco/common';

export class AuthEvent implements EventInterface {
    subject: Auth.UserTokenInterface;
    constructor(token: Auth.UserTokenInterface) {
        this.subject = token;
    }
}
